
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import { EstadisticaVentas, Articulo } from '@/__env/lib/Articulos';
    import { WaitEntre } from '@/__env/ext';

    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }


        @Prop( { type: Articulo } )
        public Articulo: Articulo;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {

        }


    }
